/* istanbul ignore file */
export const getCommentsModalState = (state) => state.tripboard.comments;


// WEBPACK FOOTER //
// ./src/universal/tripboard/comments/selectors.js